module.exports = function (e) {
  function r(n) {
    if (t[n]) return t[n].exports;
    var i = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
  }

  var t = {};
  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      configurable: !1,
      enumerable: !0,
      get: n
    });
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, r) {
    return Object.prototype.hasOwnProperty.call(e, r);
  }, r.p = "", r(r.s = 0);
}([function (e, r, t) {
  e.exports = t(1);
}, function (e, r, t) {
  "use strict";

  function n(e) {
    return !(!e || "function" != typeof e.hasOwnProperty || !(e.hasOwnProperty("__ownerID") || e._map && e._map.hasOwnProperty("__ownerID")));
  }

  function i(e, r) {
    var t = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];

    if (Array.isArray(r) || (r = [r]), n(e)) {
      var i = e.getIn(r.map(function (e) {
        return "".concat(e);
      }));
      return t && i ? i.toJS() : i;
    }

    return r.reduce(function (e, r) {
      return e[r];
    }, e);
  }

  function o(e) {
    return n(e) ? e.keySeq().toArray() : Object.keys(e);
  }

  function u(e, r) {
    return r ? "".concat(e).concat(r) : null;
  }

  function a(e, r, t, n, i) {
    var o = n.ignoreLinks,
        u = r.relationships[t];
    if (void 0 !== u.data) return Array.isArray(u.data) ? u.data.map(function (r) {
      return c(e, r.type, r.id, n, i) || r;
    }) : null === u.data ? null : c(e, u.data.type, u.data.id, n, i) || u.data;
    if (!o && u.links) throw new Error("Remote lazy loading is not supported (see: https://github.com/yury-dymov/json-api-normalizer/issues/2). To disable this error, include option 'ignoreLinks: true' in the build function like so: build(reducer, type, id, { ignoreLinks: true })");
  }

  function c(e, r) {
    var t = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null,
        n = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
        l = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : {},
        s = {
      eager: !1,
      ignoreLinks: !1,
      includeType: !1
    },
        d = Object.assign({}, s, n),
        f = d.eager,
        p = d.includeType;
    if (!i(e, r)) return null;

    if (null === t || Array.isArray(t)) {
      return (t || o(i(e, r))).map(function (t) {
        return c(e, r, t, d, l);
      });
    }

    var y = t.toString(),
        v = u(r, y),
        b = l[v];
    if (b) return b;
    var g = {},
        h = i(e, [r, y], !0);
    return h ? (h.id && (g.id = h.id), h.attributes && (Object.keys(h.attributes).forEach(function (e) {
      g[e] = h.attributes[e];
    }), Object.defineProperty(g, "resolved", {
      value: !0
    })), h.meta && (g.meta = h.meta), h.links && (g.links = h.links), p && !g.type && (g.type = r), l[v] = g, h.relationships && Object.keys(h.relationships).forEach(function (r) {
      f ? g[r] = a(e, h, r, d, l) : Object.defineProperty(g, r, {
        enumerable: !0,
        get: function get() {
          var t = "__".concat(r);
          if (g[t]) return g[t];
          var n = a(e, h, r, d, l);
          return Object.defineProperty(g, t, {
            enumerable: !1,
            value: n
          }), g[t];
        }
      });
    }), void 0 === g.id && (g.id = y), g) : null;
  }

  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = c;
}]);